<template>
    <div v-if="items" :class="['custom-select', type, customClass]">
        <custom-select-item
            v-for="item in items"
            :key="item.value"
            :value="item.value"
            :cls="item.cls"
            :text="item.text"
            :color="item.color"
            :icon="item.icon"
            :image="item.image"
            :disabled="item.disabled"
            :ref="getRef(item.value)"
            @click="handleItemClick(item)"
            :selected="isSelected(item)"/>
    </div>
</template>

<script>
import CustomSelectItem from "../atoms/CustomSelectItem.vue";

export default {
    name: "CustomSelect",
    props: {
        value: {
            type: Array,
            default: () => []
        },
        items: Array,
        type: {
            type: String,
            required: false,
            default: 'grid'
        },
        customClass: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            selectedItems: this.value
        };
    },
    components: {
        'custom-select-item': CustomSelectItem
    },
    watch: {
        value: function (value) {
            this.selectedItems = value;
        },
    },
    methods: {
        getRef(value) {
            return value + 'CustomSelectItem';
        },
        handleItemClick(item) {
            const index = this.selectedItems.findIndex(selectedItem => selectedItem.value === item.value);
            if (index === -1) {
                this.selectedItems.push(item);
            } else {
                this.selectedItems.splice(index, 1);
            }
            this.$emit('input', this.selectedItems);
        },
        isSelected(item) {
            return this.selectedItems.some(selectedItem => selectedItem.value === item.value);
        },
        selectItem(itemValue) {
            const item = this.items.find(item => item.value === itemValue);
            if (item) {
                this.handleItemClick(item);
            }
        }
    },
}
</script>
